import { render, staticRenderFns } from "./LoyaltyStockAddComponent.vue?vue&type=template&id=68ac9b71&scoped=true"
import script from "./LoyaltyStockAddComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyStockAddComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ac9b71",
  null
  
)

export default component.exports